<section class="page-card character-roster">
  <app-back-button-component />

  <h2 class="section-title">Your Characters</h2>
  <p class="empty-copy">
    Every session below is one where your adventurer already has a place at the table.
  </p>

  @if (isLoadingSessions()) {
    <app-loading-component
      [flavorTextOptions]="[
        'Gathering party ledgers from the game table.',
        'Checking which sessions already bear your character seal.',
        'Unrolling the campaign roster for your next adventure.',
        'Sorting session notes by the marks beside your name.'
      ]"
    />
  } @else if (loadSessionsError()) {
    <p class="validation-text">{{ loadSessionsError() }}</p>
  } @else if (!characterSessions().length) {
    <p class="empty-copy">
      No sessions were found with one of your characters yet.
    </p>
  } @else {
    <div class="list-grid">
      @for (entry of characterSessions(); track entry.session.id + '-' + entry.characterId) {
        <article class="list-card">
          <div class="session-kicker">{{ entry.session.universeName || 'Unknown Universe' }}</div>
          <h3>{{ entry.session.name }}</h3>
          <p>{{ entry.session.description || 'No session description has been written yet.' }}</p>
          <dl class="session-meta">
            <div>
              <dt>Campaign</dt>
              <dd>{{ entry.session.campaignName || 'Unassigned Campaign' }}</dd>
            </div>
            <div>
              <dt>Character</dt>
              <dd>{{ getCharacterName(entry.session.id, entry.characterId) }}</dd>
            </div>
          </dl>

          <a
            class="primary-btn"
            [routerLink]="['/characters', entry.session.id, entry.characterId]"
          >
            Open Character Sheet
          </a>
        </article>
      }
    </div>
  }
</section>
